import { wrapPageElement as wrapPage } from "./wrap-with-provider"

export const wrapPageElement = wrapPage
